import styled from 'styled-components';

const NotificationsContainer = styled.div`
    position: fixed;
    top: ${({ theme }) => `${theme.spacing.fixed['3']}px`};
    z-index: 1002;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${({ theme }) => `${theme.spacing.fixed['2']}px`};
    width: 100%;
    padding-inline: ${({ theme }) => `${theme.spacing.fixed['3']}px`};
`;

const NotificationContainer = styled.div`
    width: 100%;
    max-width: 800px;
`;

export { NotificationsContainer, NotificationContainer };
